import * as React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CircularProgress } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
const theme = createTheme();

theme.typography.h5 = {
  fontSize: "18px",
  "@media (min-width:600px)": {
    fontSize: "21px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "21px",
  },
};
theme.typography.body1 = {
  fontSize: "16px",
  "@media (min-width:600px)": {
    fontSize: "19px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "19px",
  },
};

const SingleBlogCard = ({ singlebloglist, isLoading }) => {
  return (
    <Grid item xs={12} sm={12} md={12}>
          {isLoading && <CircularProgress />}
      <ThemeProvider theme={theme}>
        <Card
          className="CardBG customboxshadow"
          sx={{ boxShadow: 4, borderRadius: 3, py: 2 }}
        >
          <CardMedia
            height="300px"
            width="100%"
            component="img"
            sx={{ mx: "auto" }}
            image={singlebloglist?.image}
            alt="green iguana"
          />
          <CardContent>
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              sx={{ mt: 3 }}
              className="cardtextwhite"
            >
              {singlebloglist?.name}
            </Typography>
            <Typography
              variant="body1"
              color="text.primary"
              className="cardtextwhite"
            >
              {singlebloglist?.description}
            </Typography>
            {/* <Typography variant="body1" color="text.primary" className="cardtextwhite">
      {singlebloglist?.description.slice(0, 140)}        
    </Typography> */}
          </CardContent>
          {/* <CardContent className="blogcardbottom" sx={{ textAlign: "center"}}>
    <Link style={{ textDecoration: "none", color: "black" }} to="/shops">
      <Button className="button-beguni" variant="contained">Details+</Button>
    </Link>

  </CardContent> */}
        </Card>
      </ThemeProvider>
    </Grid>
  );
};

export default SingleBlogCard;
